module.exports = __webpack_public_path__ + "static/media/sell-used-cars.309edd6f.png";